import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import InputField from './InputField';
import { tarifaImpuestos, tipoImpuesto, tipoDocumentoExoneracion, NombreInstitucionEmiteExoneracion } from '../../catalogos';
import { getExoneracion, clearErrors } from '../../actions';
import { IsNotNullOrEmptyOrUndefined } from '../../util';

const exoneracion = {
  TipoDocumento: '01',
  NumeroDocumento: '',
  NombreInstitucion: '01',
  FechaEmision: null,
  TarifaExonerada: 0,
  MontoExoneracion: 0,
  Articulo: null,
  Inciso: null,
};

const Impuestos = (props) => {
  const { codigoCabys, onSelectImpuesto, impuesto, exoneracionHacienda, errorState } = props;
  const [nuevoImpuesto, setNuevoImpuesto] = useState(impuesto);
  const [isExonerado, setIsExonerado] = useState(false);
  const [message, setMessage] = useState('');
  const [isShown, setIsShown] = useState(false);
  const [valid, setIsValid] = useState(true);

  useEffect(() => {
    if (impuesto.Exoneracion != null) {
      setNuevoImpuesto({ ...nuevoImpuesto, Codigo: '02' });
      setIsExonerado(true);
    }
  }, [impuesto]);

  useEffect(() => {
    setMessage('');
    if (exoneracionHacienda && exoneracionHacienda.exoneracion !== null) {
      setNuevoImpuesto(
        {
          ...nuevoImpuesto,
          Exoneracion: {
            TipoDocumentoEX1: exoneracionHacienda.exoneracion.tipoDocumento.codigo,
            NumeroDocumento: exoneracionHacienda.exoneracion.numeroDocumento,
            NombreInstitucion: exoneracionHacienda.exoneracion.CodigoInstitucion,
            FechaEmisionEX: exoneracionHacienda.exoneracion.fechaEmision,
            TarifaExonerada: exoneracionHacienda.exoneracion.porcentajeExoneracion,
            Articulo: exoneracionHacienda.exoneracion.articulo,
            Inciso: exoneracionHacienda.exoneracion.inciso,
          }
        });
    }
    if (errorState.error !== null) {
      setMessage(`El numero documento "${nuevoImpuesto.Exoneracion?.NumeroDocumento}" no es válido`);
      setNuevoImpuesto(
        {
          ...nuevoImpuesto,
          Exoneracion: {
            TipoDocumentoEX1: '01',
            NombreInstitucion: '01',
            FechaEmisionEX: null,
            TarifaExonerada: 0,
          }
        });
    } else {
      setMessage('');
    }
    if (IsNotNullOrEmptyOrUndefined(nuevoImpuesto.Exoneracion?.NumeroDocumento)) {
      if (IsNotNullOrEmptyOrUndefined(exoneracionHacienda)) {
        if (!IsNotNullOrEmptyOrUndefined(existeCabys(exoneracionHacienda?.exoneracion?.cabys, codigoCabys))) {
          setMessage("El código cabys " + codigoCabys + " no esta autorizado para ser exonerado");
        } else {
          setMessage('');
        }
      }

    }

  }, [exoneracionHacienda, errorState])


  const existeCabys = (array, dato) => {

    if (!IsNotNullOrEmptyOrUndefined(array)) {
      return true;
    }

    return array.filter((item) => item === dato)[0];
  };
  const updateImpuesto = (field) => {
    const { Codigo, CodigoTarifa } = field;
    const tarifa = tarifaImpuestos.find((item) => item.value === CodigoTarifa);

    if (Codigo === '02') {
      setIsExonerado(true);
      setNuevoImpuesto({ ...nuevoImpuesto, ...field, Tarifa: tarifa.tarifa, Exoneracion: exoneracion });
    } else {
      setIsExonerado(false);
      setNuevoImpuesto({ ...nuevoImpuesto, ...field, Tarifa: tarifa.tarifa });
    }
  };

  const updateExoneracion = (field) => {
    if(field.TipoDocumentoEX1 !== undefined && field.TipoDocumentoEX1 === "08"){
        setNuevoImpuesto(
        {
          ...nuevoImpuesto,
          Exoneracion: { ...nuevoImpuesto.Exoneracion, ...field, Articulo: 9, Inciso: 1 }
        });
    }
    else {
     setNuevoImpuesto(
      {
        ...nuevoImpuesto,
        Exoneracion: { ...nuevoImpuesto.Exoneracion, ...field }
      });
   }
  }

  const validarImpuesto = () => {
    setIsValid(true);
    if (isExonerado) {
      if (nuevoImpuesto.Exoneracion.TarifaExonerada <= 0) {
        setIsValid(false);
      }

      onSelectImpuesto(
        {
          ...nuevoImpuesto,
          Codigo: '01',
        });
    }

    if (!isExonerado) {
      onSelectImpuesto(
        {
          ...nuevoImpuesto,
          Exoneracion: null,
        });
    }

    //Exento
    if (nuevoImpuesto?.Codigo === '00') {
      onSelectImpuesto(null);
    }

  }

  const validarExoneracion = (documento) => {
    props.clearErrors();
    setMessage('');
    props.getExoneracion(documento);

  }

  const ExoneracionDocumentoLabel = () => (
    <>
      <label>Número de documento</label>
      <i className="check circle outline icon buscar-icon"
        onMouseEnter={() => setIsShown(true)}
        onMouseLeave={() => setIsShown(false)}
        onClick={(e) => validarExoneracion(nuevoImpuesto?.Exoneracion?.NumeroDocumento)}></i>
      {(isShown && <div className="tooltip">Validar Documento</div>)}
    </>
  );

  const hiddenExoneracion = () => isExonerado ? '' : ' hidden-field';

  return (
    <div className="ui form grid add-impuesto-container">
      <div className="doubling two column row">
        <div className="column">
          <InputField
            label="Tipo impuesto"
            type="select"
            onChange={(e) => updateImpuesto({ Codigo: e.target.value, CodigoTarifa: impuesto.CodigoTarifa })}
            options={tipoImpuesto}
            value={nuevoImpuesto?.Codigo}
          />
        </div>
        <div className="column">
          <InputField
            label="Tarifa del impuesto"
            type="select"
            onChange={(e) => updateImpuesto({ CodigoTarifa: e.target.value })}
            options={tarifaImpuestos}
            value={nuevoImpuesto?.CodigoTarifa}
            disabled={nuevoImpuesto?.Codigo !== '01'}
          />
        </div>
        <div className={`column${hiddenExoneracion()}`}>
          <InputField
            label="Tipo de exoneración"
            type="select"
            onChange={(e) => updateExoneracion({ TipoDocumentoEX1: e.target.value })}
            options={tipoDocumentoExoneracion}
            value={nuevoImpuesto?.Exoneracion?.TipoDocumentoEX1}
          />
        </div>
        <div className={`column${hiddenExoneracion()}`}>
          <InputField
            label={ExoneracionDocumentoLabel()}
            value={nuevoImpuesto?.Exoneracion?.NumeroDocumento}
            type="text"
            onChange={(e) => updateExoneracion({ NumeroDocumento: e.target.value })}
            placeholder="AL-xxxxxxxx-xx"
            maxLength="20"
            required={true}
          />
        </div>
        <div className={`column${hiddenExoneracion()}`}>
          <InputField
            label="Nombre de la institución"
            value={nuevoImpuesto?.Exoneracion?.NombreInstitucion}
             options={NombreInstitucionEmiteExoneracion}
             type="select"
            onChange={(e) => updateExoneracion({ NombreInstitucion: e.target.value })}
          />
        </div>
        <div className={`column${hiddenExoneracion()}`}>
          <InputField
            label="Fecha emisión"
            value={nuevoImpuesto?.Exoneracion?.FechaEmisionEX}
            type="datePicker"
            onChange={(e) => updateExoneracion({ FechaEmisionEx: e?._d })}
            placeholder="DD-MM-YYYY"
          />
        </div>
        <div className={`column${hiddenExoneracion()}`}>
          <InputField
            label="Porcentaje de exoneración"
            value={nuevoImpuesto?.Exoneracion?.TarifaExonerada}
            type="text"
            onChange={(e) => updateExoneracion({ TarifaExonerada: e.target.value })}
            pattern="^[0-9]+(.[0-9]{0,2})?$"
          />
        </div>
        <div className="bottom aligned right aligned sixteen wide column">
          <button
            className="ui positive basic button"
            onClick={() => validarImpuesto()}
            disabled={message !== ''}
            type="button">Agregar</button>
        </div>
      </div>
      <div className="error-message">
        <span>
          {message}
        </span>
      </div>
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    exoneracionHacienda: state.exoneracionState,
    errorState: state.errorState,
  };
}

export default connect(mapStateToProps, { getExoneracion, clearErrors })(Impuestos);